import { useConfig } from "../contexts/ConfigContext";
import { useSale } from "../contexts/SaleContext";
import { addToUniquesArray, createId, formatInputNumber, getItemTaxes, getTotalTaxes, parseInputNumber, resizeText, roundValue, textNumberFormater } from "../utils";
import React, { useEffect, useRef, useState } from "react";
import { mutate } from "swr";
import { useRegister } from "../contexts/RegisterContext";
import { Col, Empty, Form, Input, InputNumber, message, Modal, Row, Skeleton, Spin, TableColumnsType } from "antd";
import Table, { ColumnType } from "antd/es/table";
import { useItems } from "../hooks/useInventory";
import useAuth from "../hooks/useAuth";
import { useCompany } from "../contexts/CompanyContext";
import { SearchOutlined } from "@ant-design/icons";
import InputSearchItem from "./InputSearchItem";
import { useSecureRequest } from "../hooks/useSecureRequest";
import { TMovementElementItem, IMovementRS, TModuleOptions } from "../models/salesModel";
import { TStorageItemRS } from "../models/storageModel";
import { usePos } from "../contexts/PosContext";
import { useSession } from "../contexts/CashSessionContext";
import { useUser } from "../contexts/UserContext";
import { app } from "../config/const";

function AddSaleItemModal(_props:any){
  const {config} = useConfig()
  const {company} = useCompany()
  const {pos} = usePos()
  const {session} = useSession()
  const {user} = useUser()
  const idCounter = useRef(-1);
  const getNextId = () => --idCounter.current;
  const {tokenData} = useAuth.useToken("crsfAuthToken",config.session,config.key)
  const {data:items} = useItems(tokenData,{
    company:company.current.uid,
    module:config.module
  })
  const {sale,updateSale} = useSale()
  const {register,updateRegister} = useRegister()
  const [loading, setLoading] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const [messageApi, contextHolder] = message.useMessage();
  const { securePost } = useSecureRequest()
  const {taxesOptions} = register
  const enableStorage = company.moduleList.some((el:any) => el.app.toUpperCase() === app.Storage)
  const [form] = Form.useForm();
  let newPending = true
  useEffect(()=>{
    if(tokenData && items?.itemList){
      updateRegister({registerList:items.itemList})
      setSkeleton(false)
    }
  },[tokenData,items])

  const products = register.registerList.map((el,i)=>{
    const code = el.custom_id || el.uid
    return {...el,key:i,code}
  })
  console.log(sale.pendingList,sale.item_list)
  
  const createElement = async (values:any,index:any) => {
    const fromForm = index === undefined
   if(fromForm) {
      const element:Partial<TMovementElementItem> = {
        id: getNextId(),
        name: values.name,
        item_name: values.name,
        item_code: values.id,
        item_description: values.description,
        key: createId(6),
        uid: createId(10),
        register: register.registerList.length + 1,
        document_id: sale.currentPending?.id,
        display:'N/A',
        measure_unit: "UN",
        quantity: 1,
        quantity_available: -1,
        taxes_list: [],
        total_amount: roundValue(values.price),
        discount_amount: 0,
        discount_rate: 0,
        total_amount_full: roundValue(values.price),
        total_amount_net: roundValue(values.price),
        unit_price: roundValue(values.price),
        register_type: "TMPL",
        total_tax_amount: 0, 
        module_options: [], 
        custom_id: values.id
      }
      return element
    }else{
      let inventoryItem:TStorageItemRS 
      const itemResponse = await securePost('/inventory/item/get-item',{
        company:company.current.uid,uidItem: values.uid,
        module: config.module
      })
      if(itemResponse.status === 200 && itemResponse.inventoryItem){
        inventoryItem = itemResponse.inventoryItem
        //Validar disponibilidad del item
        const storehouseUid = pos.currentSelected?.storehouse_uid
        const quantity = (inventoryItem.inventory || []).find((el: any) => el.uid === storehouseUid)?.quantity || 0
        let isStockOverride = false
        let stockOverrideReason = ""
        if(inventoryItem.register_type === "PRODUCT" && quantity<1){
          const canAuthorize = user.permissions.actions?.includes('sales.action.movement.stock_override') || 
                                user.roles?.some((r: any) => ['SUPER_ADMIN', 'ADMIN_COMPANY', 'SALES_ADMIN'].includes(r.role_name) || ['SUPER_ADMIN', 'ADMIN_COMPANY', 'SALES_ADMIN'].includes(r.name))
          if(!canAuthorize){
            setLoading(false)
            return false
          }
          const reason = window.prompt(
            `El artículo "${inventoryItem.name || 'seleccionado'}" no cuenta con unidades disponibles en este almacén (Stock actual: ${quantity}).\n\nPor favor ingrese el motivo para autorizar la venta de este artículo sin inventario disponible (OBLIGATORIO):`
          )
          if(!reason?.trim()){
            alert("Operación cancelada: Se requiere ingresar el motivo para autorizar la venta sin inventario disponible.")
            setLoading(false)
            return "CANCELLED"
          }
          isStockOverride = true
          stockOverrideReason = reason.trim()
        }
        const discountRate = inventoryItem.sell_discount || 0;
        const discountAmount = roundValue(discountRate * (inventoryItem.sell_price / 100));
        const tempItem: any = {
          ...inventoryItem,
          quantity: 1,
          unit_price: roundValue(inventoryItem.sell_price),
          discount_rate: discountRate,
          discount_amount: discountAmount,
          total_amount: roundValue(inventoryItem.sell_price)
        };
        const itemTaxesList = getItemTaxes(tempItem, register.taxesOptions || []);
        itemTaxesList.forEach(tax => tax.tax_amount = roundValue(tax.tax_amount));
        const itemTaxAmount = roundValue(itemTaxesList.reduce((acc, obj) => acc + obj.tax_amount, 0));
        const fullPrice = roundValue(inventoryItem.sell_price + itemTaxAmount);
        const netPrice = roundValue(inventoryItem.sell_price - discountAmount + itemTaxAmount);
        const purchaseCost = roundValue(inventoryItem.purchase_price || 0);
        const movementItem: Partial<TMovementElementItem> = {
          ...inventoryItem,
          quantity_available: quantity,
          quantity: 1,
          total_amount: roundValue(inventoryItem.sell_price),
          discount_amount: discountAmount,
          discount_rate: discountRate,
          unit_price: roundValue(inventoryItem.sell_price),
          unit_cost: purchaseCost,
          total_cost: purchaseCost,
          purchase_price: purchaseCost,
          taxes_list: itemTaxesList,
          total_tax_amount: itemTaxAmount,
          total_amount_full: fullPrice,
          total_amount_net: netPrice,
          stock_override: isStockOverride,
          stock_override_reason: stockOverrideReason
        };
        return movementItem;
      }
      return false
    } 
  }
  const createPending = (itemList:TMovementElementItem[]) => {
    let pending:Partial<IMovementRS> = {taxes_list:[]}
    pending.cash_session_uid = session.currentSelected?.uid || ""
    pending.cash_session_id = session.currentSelected?.id
    if(itemList.length === 0){
      newPending = true
      console.log("Creado pending")
      pending.id= getNextId()
      pending.document_number = `FACT${createId(6)}`
      pending.created_by_user_document = user.document_number
      pending.created_by_user_id = user.id
      pending.created_by_user_name = user.name
    }else{
      newPending = false
      const currentPending = sale.currentPending 
      pending.id = currentPending?.id
      pending.uid = currentPending?.uid
      pending.document_number = currentPending?.document_number
      pending.stock_override = currentPending?.stock_override || false
      pending.stock_override_reason = currentPending?.stock_override_reason
      pending.stock_override_by_user_id = currentPending?.stock_override_by_user_id
      console.log("Tomado del pending: ",currentPending)
    }
    return pending
  }
  const addElement = async (values:any,i:any=undefined)=>{
    let element = await createElement(values,i)
    if(element === "CANCELLED") return;
    if(!element){
      return alert("El elemento seleccionado no tiene unidades disponibles en este almacén")
    }
    console.log(values)
    const {item_list} = sale

    let pending = createPending(item_list)
    const newItem: TMovementElementItem = {
      ...(element as TMovementElementItem),
      key: createId(6),
      register: item_list.length + 1,
      document_id: pending.id || -1
    }
    const taxes_list = getItemTaxes(newItem, taxesOptions)
    // Round individual taxes
    taxes_list.forEach(tax => tax.tax_amount = roundValue(tax.tax_amount))
    const total_tax_amount = roundValue(taxes_list.reduce((acc,obj)=>acc+obj.tax_amount,0))
    newItem.taxes_list = taxes_list
    newItem.total_tax_amount = total_tax_amount
    newItem.total_amount_full = roundValue(newItem.total_amount + total_tax_amount)
    newItem.total_amount_net = roundValue(newItem.total_amount - (newItem.discount_amount || 0) + total_tax_amount)
    item_list.push(newItem)

    if(newItem.stock_override){
      pending.stock_override = true
      pending.stock_override_reason = newItem.stock_override_reason
      pending.stock_override_by_user_id = user.id
    }
    
    const subTotal = item_list.reduce((acc,obj)=>acc+obj.total_amount,0)
    const totalDiscount = item_list.reduce((acc,obj)=>acc+obj.discount_amount,0)
    const taxAmount = item_list.reduce((acc,obj)=>acc+obj.total_tax_amount,0)
    const totalTaxesList = getTotalTaxes(item_list)
    pending.items= item_list.length
    pending.total_amount= roundValue(subTotal)
    pending.total_discount_amount = roundValue(totalDiscount)
    pending.item_list = item_list
    pending.total_tax_amount = roundValue(taxAmount)
    pending.total_amount_full = roundValue(subTotal + taxAmount)
    pending.total_amount_net = roundValue(subTotal + taxAmount - totalDiscount)
    pending.taxes_list = totalTaxesList
    // Round total taxes list amounts
    pending.taxes_list.forEach(tax => tax.tax_amount = roundValue(tax.tax_amount))
    
    // Auto-populate fields
    pending.company_id = company.current.id
    pending.cash_session_id = session.currentSelected?.id
    pending.storehouse_from_id = pos.currentSelected?.storehouse_id
    pending.document_type = "SALE_INVOICE"
    pending.invoice_type = pending.invoice_type || "SIMPLE_RECEIPT"
    pending.status = "PENDING"
    pending.payment_term = "CASH"
    pending.created_by_user_id = user.id
    pending.approved_by_user_id = user.id
    pending.delivered_by_user_id = user.id

    const {id,uid,created_at,...newPendingData} = pending
    
    const data = {
      company:company.current.uid,
      movement: { ...newPendingData },
      module: config.module,
      typeMovement: "REGISTER_SALE"
    }
    const path = newPending ? "/inventory/movement/create-movement" : "/inventory/movement/update-movement"
    
    // For update-movement we need uidMovement
    if(!newPending){
      (data as any).uidMovement = uid
    }
    setLoading(true)
    const pendingResponse = await securePost(path,data)
    if(pendingResponse.status === 200){
      form.resetFields()
      if(newPending){
        pending.uid = pendingResponse.movementUid // In storage-backend create_movement returns movementUid
      }
      const uniquesArray = addToUniquesArray(sale.pendingList,pending,pending.id,"start")
      updateSale({showAddItem:false,pendingList:uniquesArray,item_list:item_list,currentPending:pending})
      mutate(
        key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
        undefined,
        { revalidate: true }
      )
      success()
    }else{
      fail("Por favor intente nuevamente")
    }
    setLoading(false)
  }

  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'Registro creado con éxito',
    });
  };
  const fail = (content:string) => {
    messageApi.open({
      type: 'error',
      content,
    });
  };
  

  // Columnas de la tabla con búsqueda
  const filterIconElement = (filtered:boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  const getColumnSearchProps = (dataIndex: string): ColumnType => ({
    /*
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters,confirm)} size="small" style={{ width: 90 }}>
            Limipiar
          </Button>
        </Space>
      </div>
    ),*/
    filterIcon: filterIconElement,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toString().toLowerCase())
  });

  const columns:TableColumnsType = [{
      title:"Registro",dataIndex:"code",
      sorter:(a,b)=>a.code.localeCompare(b.code),
      ...getColumnSearchProps('code')
    },
    {
      title:"Nombre",dataIndex:"name",
      render:(text)=>resizeText(text,30),
      sorter:(a,b)=>a.name.localeCompare(b.name),
      ...getColumnSearchProps('name')
    },
    {
      title:"Descripción",dataIndex:"description",
      render:(text)=>resizeText(text,30),
      sorter:(a,b)=>a.description.localeCompare(b.description),
      ...getColumnSearchProps('description')
    },
    {title: "Presentación",dataIndex:"display"},
    {title:"Precio base",dataIndex:"sell_price",render:(text)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>}
  ]
  const onCancel = () => {
    updateSale({showAddItem:false});
    form.resetFields()
  }
  return(
    <Modal 
      title={<div style={{ textAlign: "center" }}>Seleccione o cree un elemento</div>} 
      open={sale.showAddItem}
      maskClosable={false}
      okText={enableStorage ? "Salir" : "Agregar elemento"}
      cancelText="Cancelar"
      confirmLoading={loading}
      okButtonProps={enableStorage ? {onClick:()=>{onCancel()}} : {type:"primary",htmlType:"submit",form:"add-item"}}
      onCancel={onCancel}
      className="modal-responsive-md"
    >
      {contextHolder}
      <Spin size="large" tip="Procesando..." fullscreen spinning={loading}  />
      {enableStorage && <><Row style={{marginBottom:10}}>
        <Col xs={24} sm={{span:12,offset:12}} md={{span:10,offset:14}} lg={{span:8,offset:16}}>
          <InputSearchItem />
        </Col>
      </Row>
      <Skeleton active paragraph={{ rows:3}} loading={skeleton}>
        <Table 
          rowClassName={"no-padding-rows"} 
          columns={columns} 
          dataSource={products} 
          size="small" 
          locale={{emptyText:<Empty description="Parece que no se encontraron elementos en tu inventario"></Empty>}}
          scroll={{ x: 'max-content' }}
          onRow={(d,i)=>{ return {onClick:()=>void addElement(d,i),style:{cursor:"pointer"}}}}
        ></Table>
      </Skeleton></>}
      {!enableStorage && <div className="card-body">
      <h6 style={{marginTop:0,marginBottom:"0.5rem",fontWeight:500,fontSize:"1rem",lineHeight:1.2}}>Registre los datos de venta</h6>
      <Form
        form={form}
        layout="vertical"
        name="add-item"
        initialValues={{id:createId(10)}}
        scrollToFirstError={{ block: 'end', focus: true }}
        style={{ maxWidth: '800px', margin: '0 auto'}}
        onFinish={addElement}
      >
        <Row gutter={[10,10]}>
          <Col sm={6} xs={12}>
            <Form.Item
              label="Identificador"
              name="id"
              rules={[{ required: false,message:"" }]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col sm={6} xs={12}>
            <Form.Item
              label="Nombre"
              name="name"
              rules={[{ required: true,message:"" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col sm={6} xs={12}>
            <Form.Item
              label="Descripción"
              name="description"
              rules={[{ required: true,message:"" }]}
            >
              <Input  />
            </Form.Item>
          </Col>
          <Col sm={6} xs={12}>
            <Form.Item
              label="Precio"
              name="price"
              rules={[{ required: true,message:""}]}
            >
              <InputNumber 
                prefix="$"  min={1} 
                style={{width:"100%"}}
                parser={parseInputNumber}
                formatter={formatInputNumber}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      </div>}
    </Modal>
  )

}

export default AddSaleItemModal